<template>
  <router-link :to="{ name: 'Dashboard' }" :title="appName" class="brand">
    <img :src="imgSrc" :alt="appName">
  </router-link>
</template>

<script>
import { mapState } from 'vuex'
import mediaQueries from 'mixins/mediaQueries'

export default {
  name: 'Brand',
  mixins: [mediaQueries],
  computed: {
    ...mapState({
      hasMainMenuOpen: ({ mainMenu }) => mainMenu.isOpen
    }),

    appName () {
      return process.env.VUE_APP_TITLE
    },

    imgSrc () {
      if (this.isMobileDevice) {
        return this.hasMainMenuOpen
          ? require('@/assets/img/logos/99icon_black.svg')
          : require('@/assets/img/logos/99icon_white.svg')
      }

      return this.hasMainMenuOpen
        ? require('@/assets/img/logos/99icon_white.svg')
        : require('@/assets/img/logos/99icon_black.svg')
    },

    isMobileDevice () {
      return this.isMobile || this.isTablet
    }
  }
}
</script>

<style lang="scss">
.brand {
  display: block;
  height: 77px;
  left: 50%;
  opacity: 1;
  position: fixed;
  top: 24px;
  transform: translateX(-50%);
  transition: 0.2s ease-in all;
  width: 64px;
  z-index: 10;

  @media (min-width: 961px) {
    left: 96px;
    transform: none;
  }

  img {
    max-width: 100%;
  }
}
</style>
